import { mapState, mapGetters } from "vuex";


var chartsMixin = {
  computed:{
    ...mapState({
      current_period: state => state.current_period,
    }),
    ...mapGetters(["show_charts"]),
  },
  watch:{
    show_charts(after){
      if (after){
        this.buildChart()
      }
    },
    current_period(after, before){
      if(before ? before.id != after.id : false){
        this.updateChart()
      }
    }
  },
}

export default chartsMixin;
